// extracted by mini-css-extract-plugin
export var closeButton = "_l1-1";
export var closeX = "_l1-3";
export var container = "_l1-0";
export var image = "_l1-2";